import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { TenderCopyPreview } from 'endpoints.tenders';
import * as api from '~/fetch';

type Params = {
  start?: string;
  cadence?: 'weekly' | 'monthly';
  enabled?: boolean;
};

export class TenderCopyPreviewError extends Error {
  status: number;
  constructor(status: number) {
    super(`Failed to load tender copy preview (${status})`);
    this.name = 'TenderCopyPreviewError';
    this.status = status;
  }
}

export const useTenderCopyPreview = (
  tenderId: string,
  { enabled = true, ...params }: Params = {}
) =>
  useQuery<TenderCopyPreview, TenderCopyPreviewError>({
    queryKey: [
      'tender-copy-preview',
      tenderId,
      params.start ?? null,
      params.cadence ?? null,
    ],
    queryFn: async () => {
      const response = await api.tenders.copyTenderPreview(tenderId, params);
      if (!response.ok) throw new TenderCopyPreviewError(response.status);
      return (await response.json()) as TenderCopyPreview;
    },
    enabled: enabled && !!tenderId,
    staleTime: 0,
    gcTime: 5 * 60_000,
    placeholderData: keepPreviousData,
  });
